import React, { useEffect } from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import GlobalStyle from './globalStyles'
import { ReactQueryDevtools } from 'react-query/devtools'
import Feed from './pages/feed'
import { UserIdProvider } from './context/userId/userid-provider'
import { TLocale } from './types/feed'
import i18next from 'i18next'
const queryClient = new QueryClient()

export const App: React.FC = () => {
  useEffect(() => {
    const lang = new URLSearchParams(window.location.search).get('lang') as TLocale

    lang ? i18next.changeLanguage(lang) : i18next.changeLanguage('sk')
  }, [])

  return (
    <>
      <GlobalStyle />
      <QueryClientProvider client={queryClient}>
        <UserIdProvider>
          <Feed />
          {process.env.NODE_ENV !== 'production' && <ReactQueryDevtools />}
        </UserIdProvider>
      </QueryClientProvider>
    </>
  )
}

export default App
